// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widgets-library-parent-container{
    position: absolute;
    right: 0px;
    top:0;
    width: 0%;
    height: 90vh;
    padding: 0px;
    margin: 0px;
    box-sizing: border-box;
    background-color: white;
    border-radius: 0px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    animation: widgets-libary-stretch-in 0.35s ease-out 0.4s forwards;
}
@keyframes widgets-libary-stretch-in {
    from {
        width: 0;
    }
    to{
        width: 50%;
    }
}
.widgets-library-header-container{
    width: 100%;
    display: flex;
    padding: 15px 25px;
    align-items: center;
    justify-content: space-between;
    border-radius: 0px;
    box-sizing: border-box;
    background-color: rgba(155, 30, 30, 0.952);
}
.widgets-library-header-container h3{
    margin: 0px;
    color: white;
    font-weight: lighter;
}
.widgets-library-header-container p{
    margin: 0px;
    color: white;
    font-size: 20px;
    cursor: pointer;
}
.widgets-library-body-container{
    width: 100%;
    height: 92%;
    overflow: auto;
    overflow-x: hidden;
}
.widgets-library-grid{
    display: grid;
    padding: 0px 20px;
    padding-top: 20px;
    margin: 0px;
    width: 100%;
    box-sizing: border-box;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}
.widgets-bundle-container{
    margin: 10px 8px;
    padding: 20px 8px;
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    transition: box-shadow 0.2s ease;
}
.widgets-bundle-container:hover{
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.7);
}
.widgets-bundle-container img{
    height: 140px;
}
.widgets-bundle-container h4{
    width: 100%;
    color: rgb(110, 110, 110);
    font-size: 12px;
    margin: 0px 0px;
    text-align: left;
    padding-left: 10px;
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/WidgetsLibrary.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,KAAK;IACL,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,iEAAiE;AACrE;AACA;IACI;QACI,QAAQ;IACZ;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,sCAAsC;AAC1C;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;IAC1C,gCAAgC;AACpC;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".widgets-library-parent-container{\r\n    position: absolute;\r\n    right: 0px;\r\n    top:0;\r\n    width: 0%;\r\n    height: 90vh;\r\n    padding: 0px;\r\n    margin: 0px;\r\n    box-sizing: border-box;\r\n    background-color: white;\r\n    border-radius: 0px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    animation: widgets-libary-stretch-in 0.35s ease-out 0.4s forwards;\r\n}\r\n@keyframes widgets-libary-stretch-in {\r\n    from {\r\n        width: 0;\r\n    }\r\n    to{\r\n        width: 50%;\r\n    }\r\n}\r\n.widgets-library-header-container{\r\n    width: 100%;\r\n    display: flex;\r\n    padding: 15px 25px;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border-radius: 0px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.widgets-library-header-container h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-weight: lighter;\r\n}\r\n.widgets-library-header-container p{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n.widgets-library-body-container{\r\n    width: 100%;\r\n    height: 92%;\r\n    overflow: auto;\r\n    overflow-x: hidden;\r\n}\r\n.widgets-library-grid{\r\n    display: grid;\r\n    padding: 0px 20px;\r\n    padding-top: 20px;\r\n    margin: 0px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n}\r\n.widgets-bundle-container{\r\n    margin: 10px 8px;\r\n    padding: 20px 8px;\r\n    border-radius: 6px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n    transition: box-shadow 0.2s ease;\r\n}\r\n.widgets-bundle-container:hover{\r\n    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.7);\r\n}\r\n.widgets-bundle-container img{\r\n    height: 140px;\r\n}\r\n.widgets-bundle-container h4{\r\n    width: 100%;\r\n    color: rgb(110, 110, 110);\r\n    font-size: 12px;\r\n    margin: 0px 0px;\r\n    text-align: left;\r\n    padding-left: 10px;\r\n    margin-bottom: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
